module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Smartphone_16"],"path":[{"$":{"d":"M2,0V16H14V0ZM9,15H7V13H9Zm3-3H4V2h8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Smartphone_16.svg
// module id = RaSh
// module chunks = 1